import msalApi from "../config/setupMSALAxios"; // your configured Axios instance
// import axios from 'axios'

export async function fetchUserData() {
  // console.clear();
  // console.log(' *** userAPI   :    fetchUserData');
  // No need to set headers if your interceptor handles it
  const response = await msalApi.get("/api/Account/GetUserData");
  return response.data;
}

//! const to function
export async function fetchSystemOptions() {
  console.clear();
  console.log(' *** userAPI   :    fetch      SystemOptions');
  // No need to set headers if your interceptor handles it
  const response = await msalApi.get("/api/Account/GetSystemOptions");
  return response.data;
}

export const changeSecurityGroup = (groupId) => {
  // //console.clear()()
  // console.log('                    userAPI   :    changeSecurityGroup')
  return msalApi.post("/api/Account/ChangeSecurityGroup", { id: groupId }).then((response) => response.data);
};

export const setUserCredentials = (payload) => {
  // console.log(' USER    API  ***  payload')
  // console.log(userName + ' ' + userPassword)
  // console.log(payload)

  return msalApi.post("/api/Account/SetUserCredentials", { SignOn: payload.userName, Password: payload.userPassword, DateSubmitted: payload.date }).then((response) => response.data);
};
export function fetchPatientPanel() {
  return msalApi.get("/api/Patient/GetPatientPanel").then((result) => result.data);
}

// * string to controller pass  CONST vs Function
// export const fetchSessionVariable = (searchTerm) => axios.get(`/api/Account/GetSessionVariable?variableName=${searchTerm}`).then((response) => response.data)
export function fetchSessionVariable(variableName) {
  // console.clear()
  // console.log('  userAPI   :    fetchSessionVariable  str variableName')
  // console.log(variableName)
  return msalApi.get("/api/Account/GetSessionVariable", { params: { variableName } }).then((result) => result.data);
}

export function setUserSessionVariable(payload) {
  // console.clear()
  // console.log('  userAPI   :                          SetUserSessionVariable  stringOne, stringTwo')
  // console.log(payload)

  return msalApi.post("/api/Account/SetUserSessionVariable", { variableName: payload.variableName, variableValue: payload.variableValue }).then((response) => response.data);
}
